import React from 'react';
import {Link} from 'react-router-dom';
import '../styles/sections/textQuoteWithImage.scss';

function TextQuoteWithImage(props) {  
    const data = props.data;
    return (
        <div className="textQuoteWithImage">
            <div className="innerBox">
                <div className="contentSection">
                    <p>{ data.text}</p>
                    <div className="get-quote">
                        <Link to="/get-quote">
                            <img src={data.logo} alt="GET A QUOTE"/>
                            <p>CREATE YOUR OWN ONLINE SHOP</p>
                            <span className="btn pill grad-orange">GET A QUOTE</span>
                        </Link>
                    </div>
                </div>
                <div className="imageContainer">
                    <img className={data.classes} src={data.image} alt="Shopify Plus" />
                </div>
            </div>        
        </div>
    )
};

export default TextQuoteWithImage; 